import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Grid, Box } from "theme-ui";
export const ScrollableProductGridNew = ({ children, columns = 3 }) => {
    return (_jsx(Box, { sx: { flex: 1, overflow: ["scroll", "scroll", "scroll", "hidden"] }, children: _jsxs(Grid, { sx: {
                width: "100%",
                px: 0,
                "& > div": {
                    width: ["75vw", null, "auto"]
                },
                "& > div:last-child": {
                    width: 16
                }
            }, gap: [16, 16, 24, 32, 48], columns: [columns + 1, null, 2, 3], children: [children, _jsx(Box, { sx: { display: ["block", null, null, "none"] } })] }) }));
};
//# sourceMappingURL=ScrollableProductGridNew.js.map